import PropTypes from "prop-types";
import styled from "styled-components";

function DynamicSelectBoxRoles({ arrayOfData, item }) {
  let options;
  if (Array.isArray(arrayOfData) && arrayOfData.length) {
    // check if there is any data in the array first
    options = arrayOfData.map((data) => (
      <option key={data.id} value={data.role}>
        {data.name}
      </option>
    ));
  }

  return (
    <Select name={item} id={item}>
      <option>Select {item}</option>
      {options}
    </Select>
  );
}

DynamicSelectBoxRoles.propTypes = {
  arrayOfData: PropTypes.arrayOf(
    PropTypes.shape({
      map: PropTypes.func,
    })
  ),
  item: PropTypes.any,
};

const Select = styled.select`
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
`;

export default DynamicSelectBoxRoles;
